<template>
    <div class="container-fluid">
        <CustomerDetails :name="name" :product_name="product_name" :full_amount="full_amount" :residence_literal="residence_literal" :destination_literal="destination_literal" :state="state" :email="email" :customers="customers" :end_date="end_date" :start_date ="start_date " :issueDate="issueDate" :customer_dts="customer_dts" :telephone="telephone" :address="address" :error_loading="error_loading"/>
        <!-- customers table debitnote -->
        <b-row class="mb-3" style="overflow-x: hidden;">
            <b-col cols="12">
                <b-table striped responsive hover v-if="!(error_loading && error_customer) && !error_tripdts"
                :items="items"
                :fields="fields"
                :busy="isBusy">
                <template #table-busy>
                    <div class="d-flex align-items-center justify-content-around my-2">
                        <b-spinner variant="dark" style="width: 3rem; height: 3rem;"></b-spinner>
                    </div>
                </template>
                <template #cell(no)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(ins_ev)="data">
                    <b-button size="sm" variant="outline-secondary" target="_blank" :href="viva_debit+'&tr='+data.index" :disabled="vivadisabled">Debit Note</b-button>
                </template>
                </b-table>
            </b-col>

            <b-col cols="12">
                <div>
                    <b-button size="sm" variant="success" target="_blank" :href="viva_debit" :disabled="vivadisabled">Debit Note</b-button>
                </div>
            </b-col>
        </b-row>
    </div>
</template>
  <script>
  import { products, customersDtsMixin } from '@/products';
  import CustomerDetails from './CustomerDetails';
  import { BRow, BCol, BTable, BButton, BSpinner } from 'bootstrap-vue'
  
  
  export default {
    mixins: [customersDtsMixin],
    components: {
      CustomerDetails,
      BRow,
      BCol,
      BTable,
      BButton,
      BSpinner
    },
    data() {
        return {
            error_tripdts: false,
            error_customer: false,
            error_loading: false,
            isBusy: true,
            name: '',
            start_date: '',
            end_date: '',
            state: '',
            issueDate: '',
            email: '',
            product_name: '',
            full_amount: '',
            residence_literal: '',
            destination_literal: '',
            telephone: '',
            address: '',
            customers:[],
            items:[],
            fields: [
                { key: 'no', label: 'No.', sortable: true },
                { key: 'gender', label: 'Gender', sortable: true },
                { key: 'customer_name', label: 'Customer Name', sortable: true },
                { key: 'date_of_birth', label: 'Date of Birth', sortable: true },
                { key: 'age', label: 'Age', sortable: true },
                { key: 'ins_ev', label: 'Personal Debit Note', sortable: false, tdClass: 'text-nowrap' },
            ],
            vivadisabled: true,
            viva_debit:'',
            tr_token:'',
            customer_dts:null,
            on_behalf_of:'',
            t_tokenized:'',
            tr_tokenized:'',
            products,
        }
    },
    async created() {
        await this.urlParams();
        await this.getTripDts();
        await this.createDebitNote();
        await this.getCustomers();
        await this.getMember(this.on_behalf_of);
        await this.getDebitNote();
    },
    computed: {
        token_id() {
            return this.$store.state.app?.userData?.id ?? null
        },
    }
  }
  </script>
  <style>
    #jumDts {
        padding: 2rem;
    }
  </style>